var React = require('react');

function ImageGeneration (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 0C2.23858 0 0 2.23858 0 5V35C0 37.7614 2.23858 40 5 40H35C37.7614 40 40 37.7614 40 35V5C40 2.23858 37.7614 0 35 0H5ZM15 11.5C15 13.4329 13.433 15 11.5 15C9.56699 15 8 13.433 8 11.5C8 9.56699 9.56699 8 11.5 8C13.433 8 15 9.56699 15 11.5ZM11.5959 21.3937L4.06603 32.4366C3.61339 33.1004 4.08879 34 4.89223 34H35.384C36.1269 34 36.6104 33.2186 36.2789 32.5538L27.7282 15.4048C27.4018 14.7502 26.506 14.6561 26.0507 15.2286L17.8669 25.5183C17.4576 26.033 16.6714 26.0193 16.2803 25.4906L13.226 21.3623C12.8167 20.809 11.9837 20.825 11.5959 21.3937Z"}));
}

ImageGeneration.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = ImageGeneration;

ImageGeneration.default = ImageGeneration;
